<template>
  <div class="doctorPage managerPlan Manager">
    <div class="selectSearch">
      <el-form
        ref="form"
        :model="searchParams"
        class="qcFrom searchConditions"
        :inline="true"
      >
        <el-form-item label="机构名称：" prop="hospCode">
          <el-select
            v-model="searchParams.hospCode"
            placeholder="请选择机构"
            class="multiple"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in allHospitalsData.Hospitals"
              :key="index"
              :label="item.HospitalName"
              :value="item.HospitalGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模态：" prop="model">
          <el-select
            size="small"
            v-model="searchParams.model"
            style="width: 100%;"
            placeholder="请选择模态"
            clearable
          >
            <el-option
              v-for="(item, index) in modalityTypeSelect"
              :key="index"
              :label="item.Name"
              :value="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：" prop="addTime">
          <el-date-picker
            v-model="searchParams.addTime"
            type="month"
            size="small"
            style="width: 320px;"
            placeholder="请选择月份"
            value-format="yyyy-MM"
            format="yyyy-MM"
          ></el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="检查项目：" prop="checkItem">
          <el-input
            v-model="searchParams.checkItem"
            size="small"
            placeholder="请输入检查项目"
          ></el-input>
        </el-form-item>
        <el-form-item label="部位：" prop="part">
          <el-input
            v-model="searchParams.part"
            size="small"
            placeholder="请输入部位"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" size="small" @click="submitSearch" round>
            查询
          </el-button>
          <el-button size="small" @click="reset" round> 重置 </el-button>
        </el-form-item>
        <!-- <div class="addbtn-box">
          <a href="javascript:;" @click="addReport" class="addbtn">添加报告</a>
          <a href="javascript:;" @click="batchUploadReport" class="addbtn">
            批量上传报告
          </a>
        </div> -->
      </el-form>
    </div>
    <div class="centerHome">
      <div class="ccHomel">
        <div class="compentTable" v-if="tableData.length > 0">
          <el-table
            class="qcTable scrollbar"
            :data="tableData"
            ref="multipleTable"
            v-loading="loading"
            :show-overflow-tooltip="true"
          >
            <el-table-column label="序号" type="index" width="80">
              <template slot-scope="scope">
                {{
                  scope.$index +
                    1 +
                    (searchParams.pageIndex - 1) * searchParams.pageCount
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="120"
              prop="HospitalName"
              label="机构名称"
            ></el-table-column>
            <el-table-column
              min-width="140"
              prop="ModalityType"
              label="模态"
            ></el-table-column>
            <el-table-column
              prop="ScanTypes"
              label="扫描类型"
            ></el-table-column>
            <el-table-column
              prop="CheckingItems"
              label="检查项目"
              :show-overflow-tooltip="true"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="FirstApproverName"
              label="终审医生"
            ></el-table-column>
            <el-table-column
              prop="BodyParts"
              label="检查部位"
            ></el-table-column>
            <el-table-column
              prop="CreateDt"
              label="创建时间"
              width="200"
            ></el-table-column>
            <el-table-column prop="PacsUrl" label="影像链接" width="200">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="viewPacsUrl(scope.row)">
                  {{ scope.row.PacsUrl }}
                </el-button> -->
                <el-link
                  v-if="scope.row.PacsUrl"
                  type="primary"
                  :href="scope.row.PacsUrl"
                  target="_blank"
                >
                  {{ scope.row.PacsUrl }}
                </el-link>
                <span v-else>---</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                <span
                  class="table-task-btn detail"
                  @click="viewReport(scope.row)"
                >
                  查看报告
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              class="pageAll"
              align="center"
              layout="prev, pager, next"
              :total="searchParams.TotalCount"
              :page-size="searchParams.pageCount"
              :current-page="searchParams.pageIndex"
              @current-change="currentChange"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="echartslineNull">
          <div class="icon">
            <svg-icon
              class="fz18 marr4"
              icon-class="icon-default-Nodata"
            ></svg-icon>
          </div>
          <div class="text">请选择条件进行查询</div>
        </div>
      </div>
    </div>
    <reportDetailDialog v-model="dialogVisible" :reportId="ReportGuid" />
  </div>
</template>

<script>
import Api from "../../../api";
import axios from "@/js/api";
import reportDetailDialog from "./reportDetailDialog.vue";
export default {
  components: {
    reportDetailDialog,
  },
  data() {
    return {
      modalityTypeSelect: [],
      loading: false,
      dialogVisible: false,
      searchParams: {
        hospCode: "",
        model: "",
        pageIndex: 1,
        pageCount: 10,
        TotalCount: 0,
        imageState: "-1",
        addTime: "",
      },
      ReportGuid: "",
      tableData: [],
    };
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["allHospitalsData"]),
  },
  methods: {
    ...Vuex.mapActions("breadcrumb", ["getAllHospitals"]),
    // 查看报告
    viewReport(row) {
      this.dialogVisible = true;
      this.ReportGuid = row.ReportGuid;
    },
    viewPacsUrl(row) {
      window.open(row.PacsUrl, "_blank");
    },
    // 表格分页参数改变
    currentChange(val) {
      this.searchParams.pageIndex = val;
      this.getReportList();
      //   this.getDataExportList();
      // document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    submitSearch() {
      this.searchParams.pageIndex = 1;
      this.getReportList();
    },
    // 获取列表
    getReportList() {
      if (!this.searchParams.hospCode) {
        this.$message.error("请选择机构");
        return;
      }
      if (!this.searchParams.addTime) {
        this.$message.error("请选择创建时间");
        return;
      }
      this.loading = true;
      let params = {
        hospCode: this.searchParams.hospCode,
        pageIndex: this.searchParams.pageIndex,
        pageSize: this.searchParams.pageCount,
        time: this.searchParams.addTime || "",
        modality: this.searchParams.model || "",
      };
      axios
        .ajaxGet("get", Api.api.manager.GetReportListByCode, params)
        .then((res) => {
          this.loading = false;
          console.log(res, "ssssssssss");
          if (res.status === 200 && res.data.StatusCode === 200) {
            this.tableData = res.data.Data;
            this.searchParams.TotalCount = res.data.Total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    GetReportModality() {
      axios.ajaxGet("get", Api.api.manager.GetReportModality).then((res) => {
        if (res.status == 200 && res.data.StatusCode == 200) {
          this.modalityTypeSelect = res.data.Data;
        }
      });
    },
    reset() {
      this.searchParams = {
        hospCode: "",
        model: "",
        pageIndex: 1,
        pageCount: 10,
        TotalCount: 0,
        imageState: "-1",
        addTime: "",
      };
      this.tableData = [];
      // this.getReportList();
    },
  },
  activated() {
    this.getAllHospitals({
      enable: -1,
      name: "",
      pageIndex: 1,
      pageCount: 999999,
    });
  },
  created() {
    this.GetReportModality();
    // this.getReportList();
  },
};
</script>

<style lang="scss" scoped>
.doctorPage.managerPlan.Manager .addbtn-box {
  position: absolute;
  right: 10px;
  bottom: 16px;
  display: flex;
  align-items: center;
  .addbtn {
    position: initial;
    margin-right: 10px;
    margin-top: 0;
  }
}
.el-select.multiple {
  width: 300px;
  ::v-deep .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
  ::v-deep .el-select__tags {
    margin-left: 10px;
    .el-tag--info {
      display: flex;
      margin: 0;
      .el-select__tags-text {
        display: block;
        max-width: 150px;
        line-height: 28px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  ::v-deep .el-tag__close.el-icon-close {
    top: 50%;
    transform: scale(0.7) translate(0, -50%);
  }
}
.echartslineNull {
  position: absolute;
  width: 158px;
  height: 30px;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.echartslineNull .text {
  font-size: 16px;
  color: #a4a4a4;
}
.echartslineNull .icon {
  text-align: center;
  margin-bottom: 5px;
}
</style>
